(function(){
  'use strict';
  // Supply tiles navigate to native Shopify product pages. This helper only
  // refreshes the visible prices via Shopify's AJAX Product endpoint.
  var cache=new Map();
  function init(){
    var root=document.getElementById('glamo-color-demo');
    if(!root)return;
    var links=Array.from(root.querySelectorAll('a[data-glamo-supply-product-link]'));
    if(!links.length)return;
    var lang=(root.dataset.demoBuyLocale||document.documentElement.lang||'lt').toLowerCase().split('-')[0];
    var locale=lang==='ru'?'ru-RU':lang==='uk'?'uk-UA':lang==='en'?'en-IE':'lt-LT';
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR';
    var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function format(cents){
      try{return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(cents/100)}
      catch(e){return (cents/100).toFixed(2)+' €'}
    }
    function refresh(link){
      if(link.dataset.glamoPriceRequested==='1')return;
      link.dataset.glamoPriceRequested='1';
      var handle=link.dataset.glamoProductHandle;
      var priceNode=link.querySelector('[data-glamo-supply-card-price]');
      if(!handle||!priceNode)return;
      if(!cache.has(handle)){
        cache.set(handle,fetch(rootUrl+'products/'+encodeURIComponent(handle)+'.js',{
          method:'GET',credentials:'same-origin',headers:{Accept:'application/json'}
        }).then(function(response){
          if(!response.ok)throw new Error('Shopify product '+response.status);
          return response.json();
        }));
      }
      cache.get(handle).then(function(product){
        var cents=Number(product&&product.price);
        if(Number.isFinite(cents)&&cents>0){
          priceNode.textContent=format(cents);
          priceNode.dataset.glamoShopifyPrice='true';
        }
      }).catch(function(){
        // Do not show an outdated price when the Shopify product endpoint fails.
        if(priceNode.dataset.glamoShopifyPrice!=='true'){
          priceNode.textContent=lang==='ru'?'Цена в карточке товара':lang==='en'?'See price on product page':lang==='uk'?'Ціна на сторінці товару':'Kaina prekės puslapyje';
        }
      });
    }
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){observer.unobserve(entry.target);refresh(entry.target)}
        });
      },{rootMargin:'150px 0px'});
      links.forEach(function(link){observer.observe(link)});
    }else{links.forEach(refresh)}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
